module.exports = __webpack_public_path__ + "static/car1-9a188274506e8683c9dc70ece47592ca.jpg";